import script from "./QuestionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionDialog.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionDialog.vue?vue&type=style&index=0&id=f232dd50&lang=less"

const __exports__ = script;

export default __exports__